import { render, staticRenderFns } from "./pushMsg.vue?vue&type=template&id=6089ca05&"
import script from "./pushMsg.vue?vue&type=script&lang=js&"
export * from "./pushMsg.vue?vue&type=script&lang=js&"
import style0 from "./pushMsg.vue?vue&type=style&index=0&id=6089ca05&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports